import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './employerJobView.html';
import logger from '../../../shared/logger';
import './style.scss';
import { INSIGHT_TAB } from '../../position/insight/component';
import { ENGAGEMENT_AFTER_RATING, IMMEDIATE_ENGAGEMENT } from '../../../constants/positionServiceType';
import { POSITION_EVENT_FLOW_TYPES } from '../../../constants/positionEvents';
import { Recruiter } from '../../core/route/recruiterService';
import UtilsService from "../../../services/utilsService";

String.prototype.replaceAll = function (search, replacement) {
    const target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

export const SCRAPE_COMPLETE_TEMPLATE_NAME = 'Scrape completed';
export const SCRAPE_REQUEST_TEMPLATE_NAME = 'Scrape request';
export const SCRAPE_TEMPLATES_NAME = 'scrapeTemplate';
export const COMPLETE_JOB_DEFINITION_TEMPLATES_NAME = 'completeJobDefinition';

export class EmployerJobComponent {
    actions = {
        REQUEST_SCRAPE: () => this.initScrapeRequest(),
        REQUEST_SCRAPE_AGAIN: () => this.initScrapeRequest(),
        GENERATE_INSIGHT: () => this.generateInsights(),
        SEND_INSIGHT_REPORT: () => this.initInsightToEmployer(),
        RE_SEND_INSIGHT_REPORT: () => this.initInsightToEmployer(),
        ACTIVATE: () => this.activateJob(),
        RE_ACTIVATE: () => this.activateJob(),
        ACTIVATE_JOB: () => this.activateJob(),
        CLOSE_JOB: () => this.cancelJob(),
        CANCEL: () => this.cancelJob(),
        CLONE_JOB: () => this.cloneJob(),
        EDIT_JOB: () => this.editJob(),
        DELETE_JOB: () => this.deleteJob(),
        SCRAPE_COMPLETE: () => this.initCompleteScrape(),
        COMPLETE_JOB_DEFINITION: () => this.initCompleteJobDefinition(),
        SERVICE_TYPE_QUALIFIED_MENU_ITEM: () => this.updateJobServiceType({
            serviceType: ENGAGEMENT_AFTER_RATING,
            successMessage: 'SERVICE_TYPE_QUALIFIED_UPDATE_NOTIFCATION',
        }),
        SERVICE_TYPE_APPROVED_MENU_ITEM: () => this.updateJobServiceType({
            serviceType: IMMEDIATE_ENGAGEMENT,
            successMessage: 'SERVICE_TYPE_APPROVED_UPDATE_NOTIFCATION',
        }),
        EMPLOYER_VIEW_UPDATE_ASSOCIATED_EMPLOYER_REP: () => this.editAssociatedEmployerRep(),
    };

    callForAction = {};
    secondaryActions = {};
    canGenerateAutoFeedbackCandidates = false;

    /* @ngInject */
    constructor(
        $uibModal,
        $stateParams,
        PositionService,
        RouteService,
        CommonCodeService,
        $localStorage,
        $cookies,
        $state,
        RecruiterService,
        searchCacheService,
        $sessionStorage,
        WorkflowService,
        $scope,
        $filter,
        TalentService,
        EmployerService,
        CandidateService,
        PositionReportService,
        permissions,
        NotificationService,
        EnvSettings,
        EmployerWorkflowStepResolver,
        PositionEventsService,
        MessageService,
        $timeout,
        utils,
        ImpersonationService,
        EmailService,
        DOMAIN_CONFIG,
        EMPLOYER_REP_AUTH_FLOW,
        EMPLOYER_WORKFLOW_STATUS,
        SemiDynamicMetadataService,
        LocationService,
        staticDataService,
        WebAppRouteService,
    ) {
        const employerJobCtrl = this;

        this.$state = $state;
        this.$scope = $scope;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$uibModal = $uibModal;
        this.notificationService = NotificationService;
        this.emailService = EmailService;
        this.recruiterService = RecruiterService;
        this.routeService = RouteService;
        this.emailService = EmailService;
        this.messageService = MessageService;
        this.EnvSettings = EnvSettings;
        this.EMPLOYER_REP_AUTH_FLOW = EMPLOYER_REP_AUTH_FLOW;
        this.positionEventService = PositionEventsService;
        this.positionService = PositionService;
        this.permissions = permissions;
        this.positionEventsService = PositionEventsService;
        this.CommonCodeService = CommonCodeService;

        this.$scope.eligableForEditJobStatuses = ['Draft', 'Active', 'Ready', 'Cancelled', 'Finished'];

        this.handleSelectedTab();

        employerJobCtrl.init = async function () {
            employerJobCtrl.cloneJobData = {};
            employerJobCtrl.asideForm = 'default';
            employerJobCtrl.positionId = $stateParams.positionId;
            employerJobCtrl.recruiterId = null;
            employerJobCtrl.isEmployerRoleOnly = !permissions.isTalenyaUser() && permissions.isEmployerUser();
            employerJobCtrl.searchDataUrl = `shared/position/${$stateParams.positionId}/tpa-search-data-popup`;

            const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));

            employerJobCtrl.startLoading();
            const isTe = ((permissions.isTalentExpertUser() || permissions.isTalentExpertUser())
                && userPrefs?.entityId);
            if (isTe) {
                const recruiter = await ImpersonationService.getBehalfOfOrCurrentTalentExpertRoleData();

                employerJobCtrl.recruiterId = recruiter._id;
                employerJobCtrl.recruiterData = recruiter;
            }
            PositionService.getPositionReports($stateParams.positionId)
                .then((insightBlocks) => { employerJobCtrl.insightBlocks = insightBlocks; })
                .catch(err => logger.error(err));
            employerJobCtrl.summernoteOptions = {
                defaultFontName: 'Arial',
                toolbar: [
                    ['style', ['bold', 'italic', 'underline']],
                    ['alignment', ['ul']],
                    ['insert', ['ltr', 'rtl']],
                ],
                callbacks: {
                    onInit(summernote) {
                        summernote.toolbar.hide();
                        const $win = $(window); // or $box parent container
                        const $noteEditor = $('.note-editor');
                        $win.on('click.Bst', (event) => {
                            if ($noteEditor.has(event.target).length === 0 && !$noteEditor.is(event.target)) {
                                // click outside of summernote
                                summernote.toolbar.hide();
                            }
                        });
                        summernote.editable.focus(() => {
                            summernote.toolbar.show();
                        });
                    },
                },
            };

            employerJobCtrl.criteriaFields = RouteService.getSystemPreference('searchCriteriaFields');

            employerJobCtrl.countriesList = await staticDataService.getStaticData('countries');

            await PositionService.getPosition(employerJobCtrl.positionId)
                .then((response) => {
                    employerJobCtrl.positionData = response.result;

                    employerJobCtrl.positionData.isCompleteJobDefinitionAvailable =
                        this.positionEventsService.isCompleteJobDefinitionAvailable(employerJobCtrl.positionData);
                    employerJobCtrl.positionData.isCompleteJobDefinitionRequestAvailable =
                        this.positionEventsService.isCompleteJobDefinitionRequestAvailable(employerJobCtrl.positionData);
                    employerJobCtrl.positionData.employerData = employerJobCtrl.employerCtrl.employerData;

                    employerJobCtrl.positionData.locationData = this.CommonCodeService.getLocationData(employerJobCtrl.positionData);

                    const { locationName = '', latitude = 0, longitude = 0 } = (response.result.location || {});
                    employerJobCtrl.locations = {
                        isLoading: false,
                        fetchedOptions: [],
                        selected: [{
                            value: [latitude, longitude].join(','),
                            label: locationName,
                        }],
                        hasErrors: false,
                    };

                    for (let i = 0; i < employerJobCtrl.criteriaFields.length; i++) {
                        if (employerJobCtrl.criteriaFields[i].type === 'minMaxStatic') {
                            const minIndex = _.findIndex(employerJobCtrl.positionData.desiredCandidateProfile.selected, {
                                field: employerJobCtrl.criteriaFields[i].minField,
                            });
                            const maxIndex = _.findIndex(employerJobCtrl.positionData.desiredCandidateProfile.selected, {
                                field: employerJobCtrl.criteriaFields[i].maxField,
                            });
                            if (minIndex >= 0 || maxIndex >= 0) {
                                employerJobCtrl.criteriaFields[i].check = true;
                                if (minIndex >= 0) {
                                    employerJobCtrl.criteriaFields[i].minSelected =
                                        employerJobCtrl.positionData.desiredCandidateProfile.selected[minIndex].items;
                                }
                                if (maxIndex >= 0) {
                                    employerJobCtrl.criteriaFields[i].maxSelected =
                                        employerJobCtrl.positionData.desiredCandidateProfile.selected[maxIndex].items;
                                }
                            } else {
                                employerJobCtrl.criteriaFields[i].check = false;
                            }
                        } else {
                            const index = _.findIndex(employerJobCtrl.positionData.desiredCandidateProfile.selected, {
                                field: employerJobCtrl.criteriaFields[i].field,
                            });
                            if (index >= 0) {
                                employerJobCtrl.criteriaFields[i].check = true;
                                employerJobCtrl.criteriaFields[i].selected =
                                    employerJobCtrl.positionData.desiredCandidateProfile.selected[index].items;
                            } else {
                                employerJobCtrl.criteriaFields[i].check = false;
                            }
                        }
                    }
                    // bringing candidates connected to talent expert moved to initTalentExpert
                    // once you click on Talent Expert tab the function brings the candidates

                    employerJobCtrl.updateMenuButtonsState(employerJobCtrl.positionData);

                    employerJobCtrl.stopLoading();
                })
                .catch(err => logger.error(err));
        };

        employerJobCtrl.openSearch = function () {
            $sessionStorage.searchExplainScore = null;
            PositionService.getPosition($stateParams.positionId)
                .then((response) => {
                    const positionData = response.result;
                    searchCacheService.addSearch({
                        name: null,
                        fields: RouteService.getSystemPreference('searchCriteriaFields'),
                    }, -1);

                    searchCacheService.addSearch({
                        name: `Position ${positionData.jobTitle}`,
                        fields: employerJobCtrl.criteriaFields,
                    }, 0);

                    searchCacheService.saveSearchResult(1, null);
                    $sessionStorage.previousState = {
                        state: $state.current.name,
                        params: angular.copy($stateParams),
                    };
                    $sessionStorage.positionSearchName = {
                        name: `Position ${positionData.jobTitle}`,
                        criteria: employerJobCtrl.criteriaFields,
                    };
                    $state.go('employer.search', {
                        employerId: $stateParams.employerId,
                        positionId: positionData._id,
                        currSearchHistoryIndex: 1,
                        currCandidatePage: 1,
                        talentID: null,
                        scroll: 0,
                        searchName: null,
                    });
                })
                .catch(err => logger.error(err));
        };

        employerJobCtrl.openNewSearch = function () {
            $sessionStorage.searchExplainScore = null;
            PositionService.getPosition($stateParams.positionId)
                .then((response) => {
                    const positionData = response.result;
                    searchCacheService.addSearch({
                        name: null,
                        fields: RouteService.getSystemPreference('searchCriteriaFields'),
                    }, -1);

                    searchCacheService.addSearch({
                        name: `Position ${positionData.jobTitle}`,
                        fields: employerJobCtrl.criteriaFields,
                    }, 0);

                    searchCacheService.saveSearchResult(1, null);
                    $sessionStorage.previousState = {
                        state: $state.current.name,
                        params: angular.copy($stateParams),
                    };
                    $sessionStorage.positionSearchName = {
                        name: `Position ${positionData.jobTitle}`,
                        criteria: employerJobCtrl.criteriaFields,
                    };
                    $state.go('employer.searchNew', {
                        employerId: $stateParams.employerId,
                        positionId: positionData._id,
                        history: 1,
                        page: 1,
                        talentID: null,
                        scroll: 0,
                        searchName: null,
                    });
                })
                .catch(err => logger.error(err));
        };

        employerJobCtrl.openSearchDataModal = function () {
            $('#searchDataModalDialog')
                .modal('show');
            employerJobCtrl.modalDialog = true;
            employerJobCtrl.searchDataOpened = true;
        };

        employerJobCtrl.closeSearchDataModal = function () {
            $('#searchDataModalDialog')
                .modal('hide');
            employerJobCtrl.modalDialog = false;
            employerJobCtrl.searchDataOpened = false;
        };

        employerJobCtrl.editJob = function () {
            $localStorage.employerPosition = angular.copy(employerJobCtrl.positionData);
            $state.go('employer.createJob', { positionId: employerJobCtrl.positionData._id }, { reload: true });
        };

        employerJobCtrl.goPositionsPage = (employerId) => {
            WebAppRouteService.goPositionsPage({
                employerId: employerId || employerJobCtrl.employerCtrl.employerData._id,
            });
        };

        employerJobCtrl.cancelJob = function () {
            PositionService.changePositionStatus(employerJobCtrl.positionId, {
                status: 'Cancelled',
            })
                .then(() => {
                    employerJobCtrl.goPositionsPage(employerJobCtrl.employerCtrl.employerData._id);
                })
                .catch(err => logger.error(err));
        };

        employerJobCtrl.activateJob = function () {
            PositionService.changePositionStatus(employerJobCtrl.positionId, { status: 'Active' })
                .then(() => WebAppRouteService.goToViewJobPage({
                    employerId: employerJobCtrl.employerCtrl.employerData._id,
                    positionId: employerJobCtrl.positionId,
                }))
                .catch(err => logger.error(err));
        };

        employerJobCtrl.deleteJob = function () {
            PositionService.deletePosition(employerJobCtrl.positionId)
                .then(() => {
                    employerJobCtrl.goPositionsPage(employerJobCtrl.employerCtrl.employerData._id);
                })
                .catch(err => logger.error(err));
        };

        employerJobCtrl.isValidEmployerStatusToGoTo = function (workflow) {
            const employerStatus = _.get(workflow, 'employerStatus.current');
            const lastFeedback = _.findLast(
                employerJobCtrl.positionData.feedbackOnCandidates,
                feedback => feedback.talentId === workflow.talentId,
            );
            const isGoodFeedback = _.get(lastFeedback, 'grades.[0].grade') === 1;
            return employerStatus !== EMPLOYER_WORKFLOW_STATUS.NONE || isGoodFeedback;
        };

        employerJobCtrl.getEmployerStatusLabel = function (workflow) {
            const employerStatus = _.get(workflow, 'employerStatus.current');
            const lastFeedback = _.findLast(
                employerJobCtrl.positionData.feedbackOnCandidates,
                feedback => feedback.talentId === workflow.talentId,
            );
            const isGoodFeedback = _.get(lastFeedback, 'grades.[0].grade') === 1;

            switch (employerStatus) {
                case EMPLOYER_WORKFLOW_STATUS.NONE:
                    return isGoodFeedback ? 'CONTACT_EMPLOYER' : this.EMPLOYER_WORKFLOW_STATUS.NONE;
                case EMPLOYER_WORKFLOW_STATUS.REVIEWED:
                    return 'CLAIMED_EMPLOYER';
                case EMPLOYER_WORKFLOW_STATUS.INTERVIEW_AND_ASSESSMENT:
                    return 'INTERVIEW_AND_ASSESSMENT_EMPLOYER';
                case EMPLOYER_WORKFLOW_STATUS.HIRED:
                    return 'HIRED_EMPLOYER';
                case EMPLOYER_WORKFLOW_STATUS.REJECTED:
                    return 'REJECTED_EMPLOYER';
                default:
                    break;
            }
        };

        employerJobCtrl.openCandidateWorkflow = function (workflow) {
            const employerId = employerJobCtrl.employerCtrl.employerData._id;
            const positionId = employerJobCtrl.positionId;
            let workflowStep = workflow.employerStatus.current;

            if (workflowStep === EMPLOYER_WORKFLOW_STATUS.NONE) {
                workflowStep = EMPLOYER_WORKFLOW_STATUS.CONTACT;
            }

            return WebAppRouteService.goToEmployerCandidatesPage({
                employerId,
                positionId,
                workflowStep,
            });
        };

        employerJobCtrl.openCandidateWorkflowCandidate = function (workflow) {
            const employerId = employerJobCtrl.employerCtrl.employerData._id;
            const positionId = employerJobCtrl.positionId;

            return WebAppRouteService.goToEmployerCandidatePage({
                employerId,
                positionId,
                workflowStep: workflow.employerStatus.current,
                talentId: workflow.talentId,
            });
        };

        employerJobCtrl.openCandidatesPosition = async function () {
            const employerId = employerJobCtrl.employerCtrl.employerData._id;
            const positionId = employerJobCtrl.positionId;
            const workflowStep = await EmployerWorkflowStepResolver.getWorkflowStep(positionId, employerId);

            return WebAppRouteService.goToEmployerCandidatesPage({
                employerId,
                positionId,
                workflowStep,
            });
        };

        employerJobCtrl.createUpdatePosition = function () {
            PositionService.addPosition({
                jobDescription: employerJobCtrl.positionData.jobDescription,
                _id: employerJobCtrl.positionData._id,
            }, true)
                .then(() => {
                    employerJobCtrl.editableSummary = false;
                })
                .catch(err => logger.error(err));
        };

        employerJobCtrl.createUpdateEmployer = function () {
            EmployerService.putEmployer(employerJobCtrl.employerCtrl.employerData._id, {
                description: employerJobCtrl.employerCtrl.employerData.description,
                internalNote: employerJobCtrl.employerCtrl.employerData.internalNote,
            }, true)
                .then(() => {
                    employerJobCtrl.editableOverview = false;
                    employerJobCtrl.editableTINotes = false;
                })
                .catch(err => logger.error(err));
        };

        employerJobCtrl.updatePosition = function () {
            PositionService.addPosition(employerJobCtrl.positionData, true);
        };

        employerJobCtrl.initTalentExpert = function () {
            if (employerJobCtrl.talentExpertTabLoading) {
                return;
            }
            employerJobCtrl.talentExpertTabLoading = true;
            WorkflowService.getWorkflowSearch({
                positionId: employerJobCtrl.positionId,
                employerId: employerJobCtrl.employerCtrl.employerData._id,
            })
                .then((response) => {
                    employerJobCtrl.positionData.workflowData = _.remove(response.result, workflow => workflow.employerStatus.current !== 'None');

                    const talents = {
                        talentIDs: [],
                    };
                    if (employerJobCtrl.positionData.workflowData.length > 0) {
                        RecruiterService.postRecruiterSearch({ recruiterIDs: _.map(employerJobCtrl.positionData.workflowData, 'recruiterId') })
                            .then((response) => {
                                employerJobCtrl.positionData.recruiters = response.result;
                                for (let i = 0; i < employerJobCtrl.positionData.workflowData.length; i++) {
                                    const recruiter = _.find(employerJobCtrl.positionData.recruiters, {
                                        _id: employerJobCtrl.positionData.workflowData[i].recruiterId,
                                    });
                                    if (recruiter) {
                                        employerJobCtrl.positionData.workflowData[i].recruiterData = recruiter;
                                    }
                                    talents.talentIDs.push(employerJobCtrl.positionData.workflowData[i].talentId);
                                }
                                if (talents.talentIDs.length > 0) {
                                    TalentService.postTalents(talents)
                                        .then((response) => {
                                            employerJobCtrl.talentExpertTabLoading = false;
                                            for (let i = 0; i < response.result.length; i++) {
                                                const workflow = _.find(employerJobCtrl.positionData.workflowData, {
                                                    talentId: response.result[i].talentId,
                                                });
                                                if (workflow) {
                                                    workflow.talent = response.result[i];
                                                }
                                            }
                                        });
                                }
                            })
                            .catch(err => logger.error(err));
                    } else {
                        employerJobCtrl.talentExpertTabLoading = false;
                    }
                })
                .catch(err => logger.error(err));
        };

        employerJobCtrl.initInsightData = () => employerJobCtrl.tabDisplay = 8;

        employerJobCtrl.initInsightToEmployer = function () {
            PositionService.getPositionReports($stateParams.positionId)
                .then(() => {
                    if (employerJobCtrl.insightBlocks) {
                        let language = RouteService.getUserPreference('uiLanguage');
                        if (!language) {
                            language = 'en-US';
                        }
                        RouteService.getEmailTemplates(language, 'insightTemplates')
                            .then((response) => {
                                employerJobCtrl.contactUserTemplates = [];
                                employerJobCtrl.asideForm = 'sendInsight';
                                employerJobCtrl.userData = {
                                    positionData: employerJobCtrl.positionData,
                                    emailType: 'employer',
                                };
                                if (response.result && response.result.templates) {
                                    employerJobCtrl.contactUserTemplates = EmailService.changeTemplateTags(
                                        response.result.templates,
                                        employerJobCtrl.positionData,
                                        employerJobCtrl.recruiterData,
                                        employerJobCtrl.employerCtrl.employerData,
                                    );
                                }
                            })
                            .catch(err => logger.error(err));
                    } else {
                        NotificationService.error('THERE IS NO INSIGHT REPORT YET');
                    }
                })
                .catch(err => logger.error(err));
        };

        employerJobCtrl.sendInsightToEmployer = function (type, contactData) {
            let subject = '';
            let recruiterEmail = '';
            let recruiterPhone = '';
            employerJobCtrl.loading = true;

            if (!utils.isValidEmail(contactData.email)) {
                NotificationService.error('INVALD EMAIL');
                return;
            }

            if (employerJobCtrl.recruiterData.contact.email.length > 0) {
                recruiterEmail = Recruiter.getEmail(employerJobCtrl.recruiterData);
            }
            if (employerJobCtrl.recruiterData.contact.phone.length > 0) {
                recruiterPhone = employerJobCtrl.recruiterData.contact.phone[0].value;
            }

            if (contactData.subject) {
                subject = contactData.subject.replaceAll('</p>', '\r\n');
                subject = subject.replaceAll('<span field=\'prospectFirstName\'>', '');
                subject = subject.replaceAll('<span field=\'jobTitle\'>', '');
                subject = subject.replaceAll('<span field=\'teName\'>', '');
                subject = subject.replaceAll('<span field=\'teFirstName\'>', '');
                subject = subject.replaceAll('<span field=\'teEmail\'>', '');
                subject = subject.replaceAll('<span field=\'tePhone\'>', '');
                subject = subject.replaceAll('<span field=\'employerName\'>', '');
                subject = subject.replaceAll('</span>', '');
                subject = subject.replaceAll('<br />', '\r\n');
                subject = subject.replaceAll('<br>', '\r\n');
                subject = subject.replaceAll('&nbsp;', ' ');
                subject = `<div>${subject}</div>`;
                subject = $(subject)
                    .text();
            }
            const messageEmailContent = {
                subject,
                body: contactData.content,
                destinations: [],
                source: {
                    recruiterId: employerJobCtrl.recruiterData._id,
                },
                messageContext: {
                    positionId: employerJobCtrl.positionData._id,
                },
            };

            if (contactData.email && contactData.email.length > 0) {
                RouteService.sendContactCandidateMail({
                    from: 'talentExperts',
                    body: contactData.content,
                    to: contactData.email,
                    subject,
                    talentExpertName: employerJobCtrl.recruiterData.fullName,
                    talentExpertEmail: recruiterEmail,
                    talentExpertCellPhone: recruiterPhone,
                })
                    .then(() => {
                        Promise.all([MessageService.addMessage(messageEmailContent),
                            PositionEventsService.insightSent(employerJobCtrl.positionData, employerJobCtrl.recruiterData)])
                            .then(() => {
                                NotificationService.success('INSIGHT_REPORT_SENT_SUCCESS');

                                return WebAppRouteService.goToViewJobPage({
                                    employerId: employerJobCtrl.employerCtrl.employerData._id,
                                    positionId: employerJobCtrl.positionId,
                                });
                            })
                            .catch((err) => {
                                logger.error(err);
                                employerJobCtrl.loading = false;
                                employerJobCtrl.asideForm = 'default';
                                NotificationService.error('INSIGHT_REPORT_SENT_ERROR');
                            });
                    });
            }
        };

        employerJobCtrl.generateInsights = () => {
            const anySelectedSearchCriteria = employerJobCtrl.positionData.desiredCandidateProfile.selected.length;

            if (!anySelectedSearchCriteria) {
                NotificationService.error('INSIGHT_GEN_ERROR_NO_SEARCH');

                return;
            }

            employerJobCtrl.loading = true;

            return PositionReportService.createPositionReport(employerJobCtrl.positionData._id)
                .then(() => {
                    NotificationService.success('INSIGHT_GEN_SUCCESS');

                    $state.current.data.selectedTab = INSIGHT_TAB;

                    return WebAppRouteService.goToViewJobPage({
                        employerId: employerJobCtrl.employerCtrl.employerData._id,
                        positionId: employerJobCtrl.positionId,
                    });
                })
                .catch((err) => {
                    NotificationService.error('INSIGHT_GEN_ERROR_NO_SEARCH');
                    logger.error(err);
                    employerJobCtrl.loading = false;
                });
        };

        employerJobCtrl.sendCompleteScrape = async (email) => {
            if (email.to.length === 0) {
                return NotificationService.error('COMPLETE_SCRAPPING_NOTIFICATION_MISSING_EMAIL_ADDRESS');
            }

            try {
                const subject = EmailService.cleanUpSpecificHTMLTags(email.subject || '');
                const body = email.content;
                const currentRecruiterData = employerJobCtrl.recruiterData;
                const from = EmailService.getEmailDataFromRecruiterData(currentRecruiterData);
                const emailData = {
                    subject,
                    body,
                    from,
                    to: email.to,
                    bcc: [from.email],
                };
                const messageEmailContent = {
                    subject,
                    body,
                    destinations: [],
                    source: { recruiterId: currentRecruiterData._id },
                    messageContext: { positionId: employerJobCtrl.positionData._id },
                };

                await Promise.all([
                    EmailService.sendEmail(emailData),
                    MessageService.addMessage(messageEmailContent),
                    employerJobCtrl.completeScrape(currentRecruiterData),
                ]);
            } catch (err) {
                logger.error(err);

                employerJobCtrl.loading = false;
                employerJobCtrl.notificationService.error('SCRAPE_COMPLETE_ERROR');
            } finally {
                employerJobCtrl.asideForm = 'default';
            }
        };

        employerJobCtrl.completeScrape = async (currentRecruiterData) => {
            employerJobCtrl.loading = true;

            try {
                await PositionEventsService.completeScrape(employerJobCtrl.positionData, currentRecruiterData);

                NotificationService.success('SCRAPE_COMPLETE_SUCCESS');

                return WebAppRouteService.goToViewJobPage({
                    employerId: employerJobCtrl.employerCtrl.employerData._id,
                    positionId: employerJobCtrl.positionId,
                });
            } catch (error) {
                logger.error(error);
            } finally {
                employerJobCtrl.loading = false;
            }
        };

        employerJobCtrl.cloneJob = () => {
            employerJobCtrl.openModalDialog(employerJobCtrl);
        };

        employerJobCtrl.editAssociatedEmployerRep = () => {
            const employerId = employerJobCtrl.positionData.employerId;
            const associatedEmployerRepId = employerJobCtrl.positionData.employerRepId;

            const modalInstance = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                component: 'editAssociatedEmployerRepModalCtrl',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    employerId: () => employerId,
                    associatedEmployerRepId: () => associatedEmployerRepId,
                },
            });

            modalInstance
                .result
                .then((selectedEmployerId) => {
                    employerJobCtrl.positionData.employerRepId = selectedEmployerId;
                    return PositionService.updatePosition(employerJobCtrl.positionData._id, employerJobCtrl.positionData);
                })
                .then(() => {
                    NotificationService.success('UPDATE_EMPLOYER_REP_NOTIFCATION');
                })
                .catch((err) => {
                    if (err) {
                        logger.error(err);
                        NotificationService.error(err.message);
                    }
                });
        };

        employerJobCtrl.openModalDialog = (data) => {
            employerJobCtrl.modalDialogData = data;
            $('#recruiterModalDialog')
                .modal('show');
            employerJobCtrl.modalDialog = true;
        };

        employerJobCtrl.closeModalDialog = () => {
            window.onbeforeunload = null;
            employerJobCtrl.modalDialogData = null;
            $('#recruiterModalDialog')
                .modal('hide');
            employerJobCtrl.modalDialog = false;
        };

        employerJobCtrl.initScrapeRequest = async function () {
            let language = RouteService.getUserPreference('uiLanguage');
            if (!language) {
                language = 'en-US';
            }

            try {
                const [{ result }, recruitersEmails] = await Promise.all([
                    RouteService.getEmailTemplates(language, SCRAPE_TEMPLATES_NAME),
                    RecruiterService.getAllRecruitersEmails(),
                ]);
                employerJobCtrl.contactUserTemplates = [];
                employerJobCtrl.asideForm = 'sendScrape';

                if (result && result.templates) {
                    const requestScrapeTemplate = (result.templates || []).find(({ name }) => name === SCRAPE_REQUEST_TEMPLATE_NAME);
                    const templates = EmailService.changeTemplateTags(
                        [requestScrapeTemplate],
                        employerJobCtrl.positionData,
                        employerJobCtrl.recruiterData,
                        employerJobCtrl.employerCtrl.employerData,
                    );
                    const emailsTo = (recruitersEmails || []).map(value => ({
                        value,
                        isSelected: false,
                        canRemove: true,
                    }));

                    templates.reverse();
                    employerJobCtrl.sendScrapeRequestEmailData = {
                        templates,
                        emailsTo: [{
                            value: DOMAIN_CONFIG.DATA_ANALYST_EMAIL,
                            isSelected: true,
                            canRemove: false,
                        }, ...emailsTo],
                    };
                }

                $scope.$apply();
            } catch (error) {
                logger.error(error);
            }
        };

        employerJobCtrl.initCompleteScrape = async function () {
            let language = RouteService.getUserPreference('uiLanguage');
            if (!language) {
                language = 'en-US';
            }

            try {
                const [{ result }, toEmail, recruitersEmails] = await Promise.all([
                    RouteService.getEmailTemplates(language, SCRAPE_TEMPLATES_NAME),
                    employerJobCtrl.getScrapeRequesterEmail(employerJobCtrl.positionData),
                    RecruiterService.getAllRecruitersEmails(),
                ]);

                employerJobCtrl.contactUserTemplates = [];
                employerJobCtrl.asideForm = 'completeScrape';

                if (result && result.templates) {
                    const requestScrapeTemplate = (result.templates || []).find(({ name }) => name === SCRAPE_COMPLETE_TEMPLATE_NAME);
                    const templates = EmailService.changeTemplateTags(
                        [requestScrapeTemplate],
                        employerJobCtrl.positionData,
                        employerJobCtrl.recruiterData,
                        employerJobCtrl.employerCtrl.employerData,
                    );
                    templates.reverse();

                    const emailsTo = (recruitersEmails || []).map(value => ({
                        value,
                        isSelected: false,
                        canRemove: true,
                    }));

                    employerJobCtrl.completeScrapeRequestEmailData = {
                        templates,
                        emailsTo: [{
                            value: toEmail,
                            isSelected: true,
                            canRemove: true,
                        }, ...emailsTo],
                    };
                }

                $scope.$apply();
            } catch (error) {
                logger.error(error);
            }
        };

        employerJobCtrl.sendScrapeRequest = async function (email) {
            if (email.to.length === 0) {
                return NotificationService.error('REQUEST_SCRAPPING_NOTIFICATION_MISSING_EMAIL_ADDRESS');
            }

            try {
                const subject = EmailService.cleanUpSpecificHTMLTags(email.subject || '');
                const body = email.content;
                const currentRecruiterData = employerJobCtrl.recruiterData;
                const from = EmailService.getEmailDataFromRecruiterData(currentRecruiterData);
                const emailData = {
                    subject,
                    body,
                    from,
                    to: email.to,
                    bcc: [from.email],
                };
                const messageEmailContent = {
                    subject,
                    body,
                    destinations: [],
                    source: { recruiterId: currentRecruiterData._id },
                    messageContext: { positionId: employerJobCtrl.positionData._id },
                };

                await Promise.all([
                    EmailService.sendEmail(emailData),
                    MessageService.addMessage(messageEmailContent),
                    employerJobCtrl.requestScrape(currentRecruiterData),
                ]);
            } catch (err) {
                logger.error(err);

                employerJobCtrl.loading = false;
                employerJobCtrl.notificationService.error('SCRAPE_REQUEST_ERROR');
            } finally {
                employerJobCtrl.asideForm = 'default';
            }
        };

        employerJobCtrl.initCloneJobData = () => {
            PositionService.getPosition(employerJobCtrl.positionId)
                .then((response) => {
                    const positionData = response.result;

                    EmployerService.getEmployer(positionData.employerId)
                        .then((response) => {
                            const employerData = response.result;
                            const jobPostfix = '(Clone)';
                            employerJobCtrl.cloneJobData.positionData = angular.copy(positionData);
                            employerJobCtrl.cloneJobData.currentEmployerData = angular.copy(employerData);
                            employerJobCtrl.cloneJobData.currentEmployerName = angular.copy(employerData.name);
                            employerJobCtrl.cloneJobData.jobTitle = `${angular.copy(positionData.jobTitle)} ${jobPostfix}`;
                            employerJobCtrl.cloneJobData.isCurrentEmployer = 'true';
                            employerJobCtrl.cloneJobData.selectedEmployer = null;
                        })
                        .catch(err => logger.error(err));


                    EmployerService.getEmployers()
                        .then((response) => {
                            employerJobCtrl.cloneJobData.employerList =
                                (response.result || [])
                                    .filter((item) => {
                                        const { status: { current: currentStatus = '' } } = item;

                                        return (currentStatus === 'Active');
                                    })
                                    .sort((left, right) => {
                                        const result = left.name.toUpperCase() >= right.name.toUpperCase();
                                        return result ? 1 : -1;
                                    });
                        })
                        .catch(err => logger.error(err));
                })
                .catch(err => logger.error(err));
        };

        employerJobCtrl.cancelJobClone = () => {
            PositionService.cancelClonePosition(employerJobCtrl.buildCloneJobData())
                .then(() => NotificationService.success('JOB_CLONE_CANCELED_NOTIFICATION_SUCCESS'))
                .catch(() => NotificationService.error('JOB_CLONE_CANCELED_NOTIFICATION_ERROR'));
            employerJobCtrl.closeModalDialog();
        };

        employerJobCtrl.onLocationChange = (locations) => {
            employerJobCtrl.locations.hasErrors = employerJobCtrl.locations.selected.length > 0 && locations.length === 0;
            employerJobCtrl.locations.selected = locations;
        };

        employerJobCtrl.onLocationInput = _.debounce(async (inputValue) => {
            if (inputValue && inputValue.length > 1) {
                employerJobCtrl.locations.isLoading = true;

                try {
                    const response = await SemiDynamicMetadataService.getLocations({ text: inputValue });
                    employerJobCtrl.locations.fetchedOptions = (_.get(response, 'result.results.values', []) || [])
                        .map(({ value, text }) => ({
                            value,
                            label: text,
                        }));
                } catch (err) {
                    logger.error(err);
                } finally {
                    this.$scope.$evalAsync();
                }

                employerJobCtrl.locations.isLoading = false;
            } else {
                employerJobCtrl.locations.fetchedOptions = [];
            }
        }, 200);

        employerJobCtrl.buildCloneJobData = () => {
            const positionData = angular.copy(employerJobCtrl.cloneJobData.positionData);
            const { locationName = '', latitude = 0, longitude = 0 } = employerJobCtrl.positionData.location;
            const defaultLocation = {
                value: [latitude, longitude].join(','),
                label: locationName,
            };
            const selectedEmployer = employerJobCtrl.cloneJobData.currentEmployerData;
            const selectedLocation = employerJobCtrl.locations.selected[0] || defaultLocation;
            const location = LocationService.getLocationObjectFromDbLocationItem({
                locationItem: { text: selectedLocation.label, value: selectedLocation.value },
                countriesList: this.countriesList,
            });

            positionData.positionId = positionData._id;
            positionData._id = null;
            positionData.jobTitle = employerJobCtrl.cloneJobData.jobTitle;
            positionData.employerData = angular.copy(selectedEmployer);
            positionData.feedbackOnCandidates = [];
            positionData.migrationCode = '';
            positionData.location = location;
            positionData.employerId = (selectedEmployer || {})._id;

            return positionData;
        };

        employerJobCtrl.submitJobClone = (form) => {
            form.$setSubmitted(true);

            const isJobTitleInvalid = form.$name.$invalid || (!employerJobCtrl.cloneJobData.jobTitle);
            const [nameInput = { $invalid: true }] = form.$$controls.filter(control => control.$name === 'jobTitle');
            nameInput.$invalid = isJobTitleInvalid;

            if (employerJobCtrl.locations.selected.length === 0) {
                employerJobCtrl.locations.hasErrors = true;
                return false;
            }

            if (isJobTitleInvalid) {
                return false;
            }

            PositionService.clonePosition(employerJobCtrl.buildCloneJobData())
                .then((data) => {
                    const positionId = data.result._id;
                    const { employerId } = data.result;
                    NotificationService.success('JOB_CLONE_SAVE_SUCCESS');

                    return WebAppRouteService.goToViewJobPage({
                        employerId,
                        positionId,
                    });
                })
                .catch((err) => {
                    logger.error(err);
                    NotificationService.error('JOB_CLONE_SAVE_ERROR');
                });

            employerJobCtrl.closeModalDialog();
        };

        employerJobCtrl.runCallForAction = async (positionData) => {
            if (!positionData) {
                return;
            }

            const targetCondition = PositionEventsService.getEmployerCondition(positionData);

            if (!targetCondition) {
                return;
            }

            const [, callForActionText] = targetCondition.slice().reverse();

            if (!callForActionText) {
                return;
            }

            await this.actions[callForActionText]();
        };

        employerJobCtrl.setActionDisplay = (positionData) => {
            if (!positionData) {
                return;
            }

            const targetCondition = PositionEventsService.getEmployerCondition(positionData);

            if (!targetCondition) {
                return;
            }

            const [, callForActionText] = targetCondition.slice().reverse();

            const displayActions = {
                GENERATE_INSIGHT: () => employerJobCtrl.initInsightData(),
                SEND_INSIGHT_REPORT: () => employerJobCtrl.initInsightData(),
                RE_SEND_INSIGHT_REPORT: () => employerJobCtrl.initInsightData(),
            };
            const action = displayActions[callForActionText];

            if (action) {
                action();
            }
        };

        employerJobCtrl.requestScrape = async (currentRecruiterData) => {
            employerJobCtrl.loading = true;

            try {
                await PositionEventsService.requestScrape(employerJobCtrl.positionData, currentRecruiterData);

                NotificationService.success('SCRAPE_REQUEST_SUCCESS');

                return WebAppRouteService.goToViewJobPage({
                    employerId: employerJobCtrl.employerCtrl.employerData._id,
                    positionId: employerJobCtrl.positionId,
                });
            } catch (error) {
                logger.error(error);
                NotificationService.error('SCRAPE_REQUEST_ERROR');
            } finally {
                employerJobCtrl.loading = false;
            }
        };

        employerJobCtrl.onCloseModal = () => {
            employerJobCtrl.asideForm = 'default';
        };

        employerJobCtrl.init();
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }

    onActionButtonClick({ value, isLoading }) {
        if (!this.positionData || isLoading) {
            return;
        }

        this.actions[value]();
    }

    updateMenuButtonsState(positionData) {
        this.menuButtons = this.getMenuButtons(positionData);
    }

    getMenuButtons(positionData) {
        if (!positionData) {
            return [];
        }

        const targetCondition = this.positionEventsService.getEmployerCondition(positionData);

        if (!targetCondition) {
            return [];
        }

        const [secondaryActions, callForActionText] = targetCondition.slice().reverse();
        const isCompleteJobItemAvailable = this.positionEventsService.isCompleteJobDefinitionRequestAvailable(positionData)
            && !this.isEmployerRoleOnly;

        const positionServiceType = _.get(this.positionData, 'serviceType');

        const menuButtons = [{ value: callForActionText }];

        menuButtons.push(...(secondaryActions || []).map(value => ({ value })));

        if (isCompleteJobItemAvailable) {
            menuButtons.push({ value: 'COMPLETE_JOB_DEFINITION' });
        }

        if (!this.isEmployerRoleOnly) {
            switch (positionServiceType) {
                case IMMEDIATE_ENGAGEMENT:
                    menuButtons.push({ value: 'SERVICE_TYPE_QUALIFIED_MENU_ITEM' });
                    break;
                case ENGAGEMENT_AFTER_RATING:
                    menuButtons.push({ value: 'SERVICE_TYPE_APPROVED_MENU_ITEM' });
                    break;
                default:
                    break;
            }
        }

        menuButtons.push({ value: 'EMPLOYER_VIEW_UPDATE_ASSOCIATED_EMPLOYER_REP' });

        return menuButtons;
    }

    async initCompleteJobDefinition() {
        const language = this.routeService.getUserPreference('uiLanguage') || 'en-US';
        const { employerData } = this.employerCtrl;
        const employerEmails = _.get(employerData, 'contact.email', []).map(({ value }) => value);

        try {
            const { result } = await this.routeService.getEmailTemplates(language, COMPLETE_JOB_DEFINITION_TEMPLATES_NAME);

            if (result && result.templates) {
                this.asideForm = 'completeJobDefinition';
                this.sendCompleteJobDefinitionEmailData = {
                    templates: this.emailService.changeTemplateTags(
                        result.templates,
                        this.positionData,
                        this.recruiterData,
                        employerData,
                    ),
                    emailsTo: (employerEmails || []).map(value => ({
                        value,
                        isSelected: false,
                        canRemove: true,
                    })),
                };
            }
        } catch (error) {
            logger.error(error);
        } finally {
            this.$scope.$apply();
        }
    }

    async updateJobServiceType({ serviceType, successMessage }) {
        try {
            const { result } = await this.positionService.changeServiceType({ positionId: this.positionId, serviceType });

            if (result && result.isSuccessful) {
                this.notificationService.success(successMessage);
                this.positionData = { ...this.positionData, serviceType };
                this.updateMenuButtonsState(this.positionData);
            } else {
                this.notificationService.error('POSITION_SERVICE_TYPE_CHANGE_FAILED_ERROR_NOTIFICATION');
            }
        } catch (error) {
            this.notificationService.error('POSITION_SERVICE_TYPE_CHANGE_FAILED_ERROR_NOTIFICATION');
            logger.error(error);
        } finally {
            this.$scope.$apply();
        }
    }

    async sendCompleteJobDefinitionEmail(email) {
        if (_.isArray(email.to) && email.to.length === 0) {
            return this.notificationService.error('REQUEST_SCRAPPING_NOTIFICATION_MISSING_EMAIL_ADDRESS');
        }

        const subjectValue = (email.subject || '').trim();

        if (!subjectValue) {
            return this.notificationService.error('COMPLETE_JOB_CALIBRATION_REQUEST');
        }

        try {
            this.loading = true;

            const positionId = this.positionData._id;
            const recruiterId = this.recruiterData._id;
            const employerId = this.employerCtrl.employerData._id;
            const subject = this.emailService.cleanUpSpecificHTMLTags(email.subject || '');
            const body = email.content;
            const currentRecruiterData = this.recruiterData;
            const from = this.emailService.getEmailDataFromRecruiterData(currentRecruiterData);
            const wizardEvents = (this.positionData.events || []).filter(({ flowType }) => flowType === POSITION_EVENT_FLOW_TYPES.positionWizard);

            if (wizardEvents.length === 0) {
                await this.positionEventService.addWizardCreateJobEvent(this.positionData, currentRecruiterData);
            }

            const [, { result: talenyaBot }] = await Promise.all([
                this.positionService.sendCalibrationRequest(positionId, {
                    emails: email.to,
                    employerId,
                    recruiterId,
                    emailObj: {
                        from: 'talentExperts',
                        host: `${this.EnvSettings.Auth0RedirectUrl}`,
                        body,
                        to: email.to,
                        bcc: [from.email],
                        subject,
                        talentExpertName: from.fullName,
                        talentExpertEmail: from.email,
                        talentExpertCellPhone: from.phone,
                    },
                }),
                this.recruiterService.getTalenyaBotRecruiter(),
            ]);

            await this.positionService.addRecruiterToPosition({ positionId, recruiterId: talenyaBot._id });

            this.notificationService.success('COMPLETE_JOB_DEFINITION_REQUEST_SUCCESS');
        } catch (err) {
            logger.error(err);

            this.notificationService.error('COMPLETE_JOB_DEFINITION_REQUEST_ERROR');
        } finally {
            this.loading = false;
            this.asideForm = 'default';
            this.$scope.$apply();
        }
    }

    handleSelectedTab() {
        const { $state } = this;
        const { selectedTab } = $state.current.data;

        if (selectedTab && selectedTab === INSIGHT_TAB) {
            this.tabDisplay = 8;
        } else {
            this.tabDisplay = 1;
        }
    }

    async getScrapeRequesterEmail({ events } = {}) {
        const event = [...events || []].reverse().find(({ eventType }) => eventType === 'scrape_requested');
        const recruiterToSendId = event && event.recruiterId;
        const { result: recruiterToSendData } = await this.recruiterService.getRecruiter(recruiterToSendId);

        return Recruiter.getEmail(recruiterToSendData);
    }

    onInsightChange(insightBlocks) {
        this.insightBlocks = insightBlocks;
    }
}

export const EmployerJobComponentConfiguration = {
    template,
    require: {
        employerCtrl: '^employerComponent',
    },
    controller: EmployerJobComponent,
    controllerAs: 'employerJobCtrl',
};

angular
    .module('TALENYA-FE')
    .component('employerJobComponent', EmployerJobComponentConfiguration);
